import * as yup from "yup";
import {
  checkUrl,
  checkHtml,
  getPasswordValidationMessage,
} from "../../../utils/helper";

// Login validation schema
export const loginSchema = yup.object().shape({
  email: yup
    .string()
    .required("Email is required")
    .email("Please enter a valid email address")
    .trim(),
  password: yup.string().required("Password is required"),
});

// Sign-up validation schema
export const signUpSchema = yup.object().shape({
  fullName: yup
    .string()
    .required("Full name is required")
    .max(128, "Full name cannot exceed 128 characters")
    .test(
      "no-url",
      "Full name cannot contain URLs",
      (value) => !checkUrl(value)
    )
    .test("no-html", "Invalid full name", (value) => !checkHtml(value))
    .test("min-words", "Please enter at least your first name", (value) => {
      if (!value) return false;
      const trimmed = value.trim();
      return trimmed.length > 0;
    })
    .trim(),

  email: yup
    .string()
    .required("Email is required")
    .email("Please enter a valid email address")
    .trim(),

  password: yup
    .string()
    .required("Password is required")
    .min(8, "Password must be at least 8 characters")
    .max(32, "Password cannot exceed 32 characters")
    .test("password-strength", function (value) {
      const message = getPasswordValidationMessage(value);
      return message ? this.createError({ message }) : true;
    }),
});

// Email verification schema
export const verificationSchema = yup.object().shape({
  code: yup
    .string()
    .required("Verification code is required")
    .matches(/^\d{6}$/, "Code must be 6 digits"),
});

// Forgot password schema
export const forgotPasswordSchema = yup.object().shape({
  email: yup
    .string()
    .required("Email is required")
    .email("Please enter a valid email address")
    .trim(),
});

// Reset password schema
export const resetPasswordSchema = yup.object().shape({
  password: yup
    .string()
    .required("Password is required")
    .min(8, "Password must be at least 8 characters")
    .max(32, "Password cannot exceed 32 characters")
    .test("password-strength", function (value) {
      const message = getPasswordValidationMessage(value);
      return message ? this.createError({ message }) : true;
    }),
  confirmPassword: yup
    .string()
    .required("Please confirm your password")
    .oneOf([yup.ref("password"), null], "Passwords must match"),
});
